import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { AxiosResponse } from "axios";
import { debounce } from "lodash";
import { useMemo, useRef, useState } from "react";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";

type Props = {
  selectedStudy: { id: string; name: string } | null;
  onStudyChange: ({ id, name }: { id: string; name: string }) => void;
};

const StudySelector: React.FC<Props> = ({ selectedStudy, onStudyChange }) => {
  const [loader, setloader] = useState(false);
  const [studies, setStudies] = useState<Array<{ id: string; name: string }>>(
    []
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const handleSearch = useMemo(
    () =>
      debounce(async (value: string) => {
        try {
          if (value) {
            setloader(true);
            const res: AxiosResponse = await http.get(
              `/platform/study?page=1&size=15&query=${value}`
            );
            const studyList = res.data.data.map((study: any) => {
              return {
                id: study?.id,
                name: study?.name,
              };
            });

            setStudies(studyList);
          }
        } catch (err) {
          errorToastMessage(err as Error);
        } finally {
          setloader(false);
        }
      }, 500),
    []
  );

  return (
    <Autocomplete
      id="study-selection"
      filterOptions={(x) => x}
      onInputChange={(_1: any, value: any, reason: string) => {
        if (reason === "input") handleSearch(value);
      }}
      onChange={(_1: any, value: any) => {
        onStudyChange(value || null);
        if (value) {
          inputRef.current?.blur();
        }
      }}
      sx={{ width: 300 }}
      options={studies}
      value={selectedStudy || null}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      loading={loader}
      loadingText={<CircularProgress size={20} />}
      noOptionsText="No Results"
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.name
      }
      clearOnBlur={true}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          placeholder={selectedStudy ? undefined : "All Studies"}
          sx={{ backgroundColor: "white", borderRadius: "6px" }}
        />
      )}
    />
  );
};

export default StudySelector;
